/* eslint-disable no-param-reassign */
import firebase from 'firebase/app';
import 'firebase/firestore';

export default {
  state: {
    favors: {
      movies: [],
      tvShows: [],
      people: [],
    },
  },
  mutations: {
    setFavorsList(state, payload) {
      const moviesList = [];
      const tvShowList = [];
      const people = [];

      payload.forEach((doc) => {
        if (doc.get('type') === 'person') {
          people.push({ ...doc.data(), ...{ fbId: doc.id } });
          state.favors.people = people;
        } else if (doc.get('type') === 'movie') {
          moviesList.push({ ...doc.data(), ...{ fbId: doc.id } });
          state.favors.movies = moviesList;
        } else if (doc.get('type') === 'tvShow') {
          tvShowList.push({ ...doc.data(), ...{ fbId: doc.id } });
          state.favors.tvShows = tvShowList;
        } else {
          console.log('Favoriten-Typ in setFavorsList kann nicht zugeordnet werden!');
        }
      });
    },
  },
  actions: {
    async addToFavorList({ commit, getters }, payload) {
      console.log('addToFavorList payload:', payload);

      commit('clearError');
      // commit('setLoading', true);
      // TODO: add Timestamp to firebase!
      // sort bookmarks per last timestamp... see main.js -> orderBy('added')!!
      try {
        if (payload.type === 'movie') {
          await firebase
            .firestore()
            .collection('users')
            .doc(getters.login)
            .collection('favorites')
            .add({
              type: payload.type,
              id: payload.id,
              poster_path: payload.poster_path,
              title: payload.title,
              release_date: payload.release_date,
              vote_average: payload.vote_average,
              added: Date.now(),
            });

          // commit('setLoading', false);
          commit(
            'setUserMessage',
            `Film "${payload.title}" zu Favoriten hinzugefügt.`,
          );
        } else if (payload.type === 'tvShow') {
          await firebase
            .firestore()
            .collection('users')
            .doc(getters.login)
            .collection('favorites')
            .add({
              type: payload.type,
              id: payload.id,
              poster_path: payload.poster_path,
              name: payload.name,
              first_air_date: payload.first_air_date,
              vote_average: payload.vote_average,
              added: Date.now(),
            });

          // commit('setLoading', false);
          commit(
            'setUserMessage',
            `Serie "${payload.name}" wurde zu den Favoriten hinzugefügt.`,
          );
        } else if (payload.type === 'person') {
          await firebase
            .firestore()
            .collection('users')
            .doc(getters.login)
            .collection('favorites')
            .add({
              type: payload.type,
              id: payload.id,
              profile_path: payload.profile_path,
              name: payload.name,
              known_for: payload.known_for,
              added: Date.now(),
            });

          // commit('setLoading', false);
          commit(
            'setUserMessage',
            `"${payload.name}" wurde zu den Favoriten hinzugefügt.`,
          );
        } else {
          commit('setError', 'Favoriten-Typ noch nicht definiert');
        }
      } catch (error) {
        // commit('setLoading', false);
        commit('setError', `Uups! Da is was schief gelaufen: ${error.message}`);
      }
    },

    async deleteFromFavorList({ commit, getters }, { id, title }) {
      commit('clearError');
      // commit('setLoading', true);

      try {
        await firebase
          .firestore()
          .collection('users')
          .doc(getters.login)
          .collection('favorites')
          .doc(id)
          .delete();

        // commit('setLoading', false);
        commit('setUserMessage', `"${title}" wurde aus den Favoriten entfernt.`);
      } catch (error) {
        // commit('setLoading', false);
        commit('setError', `Uups! Da is was schief gelaufen: ${error.message}`);
      }
    },
  },
  getters: {
    getFavLength(state) {
      return state.favors.movies.length + state.favors.tvShows.length + state.favors.people.length;
    },
    getFavMovies(state) {
      return state.favors.movies.length;
    },
    getFavPeople(state) {
      return state.favors.people.length;
    },
    getFavTvShows(state) {
      return state.favors.tvShows.length;
    },

  },
};
